import ExpandableTable from "@/components/desktop/list/table/ExpandableTable";

const DistributionListMembers = ({ members = [] }) => {
	const columns = [
		{ key: "name", label: "Nombre" },
		{ key: "email", label: "Correo" },
		{ key: "phone", label: "Teléfono" },
	];

	return <ExpandableTable title="Miembros" subtitle={`Total de miembros: ${members.length}`} columns={columns} data={members} rowKey="id" fullWidth={true} />;
};

export default DistributionListMembers;
